module.exports = "/_next/static/images/creator-abstract-cover-480-2028624ecf488cc7243e3c421ada267a.webp";